import { render, staticRenderFns } from "./RentalRequestList.vue?vue&type=template&id=1e72c08c&"
import script from "./RentalRequestList.vue?vue&type=script&lang=js&"
export * from "./RentalRequestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports